/**
 * Языки ученика с сервером: при входе — список изучаемых и активный язык
 * (сервер — источник правды, другое устройство могло переключить язык),
 * а язык интерфейса, наоборот, — с этого устройства на сервер: по нему
 * сервер будет объяснять уроки.
 */

import { useEffect, useState } from 'react';

import type { LanguageCode } from '@aptile/shared';

import { fetchLanguages, saveUiLanguage } from '../api/languages';
import { useLocaleStore } from '../store/localeStore';

export function useLanguageSync(userId: string): void {
  const uiLanguage = useLocaleStore((state) => state.uiLanguage);
  const [serverUi, setServerUi] = useState<LanguageCode | null>(null);

  useEffect(() => {
    if (userId.length === 0) return undefined;
    let cancelled = false;
    // Нет сети — работаем с сохранённым активным языком, синхронизируемся в следующий запуск.
    fetchLanguages()
      .then((view) => {
        if (!cancelled) setServerUi(view.uiLanguage);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [userId]);

  useEffect(() => {
    if (serverUi === null || serverUi === uiLanguage) return;
    saveUiLanguage(uiLanguage)
      .then((view) => setServerUi(view.uiLanguage))
      .catch(() => undefined);
  }, [serverUi, uiLanguage]);
}
